import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMonthTotalCounter, getTotalCounter } from '@/api/bairun/financialCenter';
import BarChart from '@/components/Charts/BarChart';
import PieChart from '@/components/Charts/PieChart';
import dateUtils from '@/utils/dateUtil';
import NP from 'number-precision';
export default {
  name: 'SlotCounterStationBarChart',
  components: {
    BarChart: BarChart,
    PieChart: PieChart
  },
  props: {
    date: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      required: true
    },
    queryDataDays: {
      type: Number,
      required: true
    },
    slotCounterName: {
      type: String,
      required: true
    },
    slotsMapping: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      render: 0,
      render2: 0,
      render3: 0,
      totalAfterNums: 0,
      compareVal: 0,
      totalCircleNums: 0,
      totalAfterNumsSubStr: '',
      totalCircleNumsSubStr: '',
      singleAfterNums: 0,
      singleCompareVal: 0,
      singleCircleNums: 0,
      singleAfterNumsSubStr: '',
      singleCircleNumsSubStr: '',
      selectedItemId: 0,
      pieDataObj: {},
      xData: {},
      xData2: {},
      xData3: {},
      showBarData: [],
      showPieData: [],
      pieData: [],
      pieData2: [],
      barData: [],
      barData2: [],
      barData3: [],
      monthSlotsArr: [],
      switchValue: false,
      switchValue2: false,
      pieUnit: '万升',
      showPopover: false,
      metrics: [{
        title: '92#',
        key1: 'afterNums92',
        key2: 'beforeNums92',
        key3: 'circleNums92',
        value: 0,
        compare: 0
      }, {
        title: '95#',
        key1: 'afterNums95',
        key2: 'beforeNums95',
        key3: 'circleNums95',
        value: 0,
        compare: 0
      }, {
        title: '0#',
        key1: 'afterNums0',
        key2: 'beforeNums0',
        key3: 'circleNums0',
        value: 0,
        compare: 0
      }]
    };
  },
  computed: {
    slotsName: function slotsName() {
      var tmp = [];

      for (var key in this.slotsMapping) {
        tmp.push(this.slotsMapping[key]['statAbbr']);
      }

      return tmp;
    }
  },
  watch: {
    date: function date() {
      this.xData = {};
      this.xData2 = {};
      this.xData3 = {};
      this.barData = [];
      this.barData2 = [];
      this.barData3 = [];
      this.switchValue = false;
      this.switchValue2 = false;
      this.loadData(this.date);
    }
  },
  created: function created() {
    this.selectedItemId = this.totalId;
    this.loadData(this.date);
  },
  methods: {
    getTotalAfterNumsSub: function getTotalAfterNumsSub() {
      this.totalAfterNums = 0;
      this.totalCircleNums = 0;
      this.compareVal = 0;
      this.totalAfterNumsSubStr = '';

      var _that = this;

      this.metrics.forEach(function (el) {
        _that.totalAfterNums = NP.plus(_that.totalAfterNums, el.value);
        _that.totalCircleNums = NP.plus(_that.totalCircleNums, el.compare);
        _that.totalAfterNumsSubStr += el.title + ':' + NP.round(NP.divide(el.value, 10000), 2) + '万升　';
      });
      this.totalAfterNums = NP.round(NP.divide(this.totalAfterNums, 10000), 2);
      this.totalCircleNums = NP.round(NP.divide(this.totalCircleNums, 10000), 2);
      this.compareVal = this.totalCircleNums > 0 ? NP.round(NP.times(NP.divide(NP.minus(this.totalAfterNums, this.totalCircleNums), this.totalCircleNums), 100), 2) : this.totalAfterNums > 0 ? 100 : 0;
      this.totalCircleNumsSubStr = this.compareVal > 0 ? '环比：+' + this.compareVal + '%' : '环比：' + this.compareVal + '%'; // console.log('compare==', this.totalAfterNums, this.totalCircleNums, this.compareVal)

      this.selectedChange();
    },
    getSingleAfterNumsSub: function getSingleAfterNumsSub(sellerId) {
      this.singleAfterNums = 0;
      this.singleCircleNums = 0;
      this.singleCompareVal = 0;
      this.singleAfterNumsSubStr = '';
      this.singleCircleNumsSubStr = '';

      if (sellerId <= 999) {
        this.singleAfterNums = this.totalAfterNums;
        this.singleCircleNums = this.totalCircleNums;
        this.singleCompareVal = this.compareVal;
        this.singleAfterNumsSubStr = this.totalAfterNumsSubStr;
        this.singleCircleNumsSubStr = this.totalCircleNumsSubStr;
      } else {
        var singleData = this.pieDataObj[sellerId];
        this.singleAfterNums = NP.round(NP.divide(singleData.afterNums, 10000), 2);
        this.singleCircleNums = NP.round(NP.divide(singleData.circleNums, 10000), 2);
        this.singleAfterNumsSubStr = '';

        var _that = this;

        this.metrics.forEach(function (el) {
          _that.singleAfterNumsSubStr += el.title + ':' + NP.round(NP.divide(singleData[el.key1], 10000), 2) + '万升　';
        });
        this.singleCompareVal = this.singleCircleNums > 0 ? NP.round(NP.times(NP.divide(NP.minus(this.singleAfterNums, this.singleCircleNums), this.singleCircleNums), 100), 2) : this.singleAfterNums > 0 ? 100 : 0;
        this.singleCircleNumsSubStr = this.singleCompareVal > 0 ? '环比：+' + this.singleCompareVal + '%' : '环比：' + this.singleCompareVal + '%'; // console.log('single compare==', this.singleAfterNums, this.singleCircleNums, this.singleCompareVal)
      }
    },
    switchChange: function switchChange() {
      if (this.switchValue) {
        this.showBarData = this.barData2;
      } else {
        this.showBarData = this.barData;
      }

      this.render += 1;
    },
    switchChange2: function switchChange2() {
      if (this.switchValue2) {
        this.showPieData = this.pieData2;
      } else {
        this.showPieData = this.pieData;
      }

      this.render3 += 1;
    },
    loadData: function loadData(paramsDate) {
      var _this = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: 999,
          name: this.slotCounterName,
          start: paramsDate / 1000 - 24 * 60 * 60,
          end: paramsDate / 1000,
          search: ''
        }]
      };
      getTotalCounter(descriptorData).then(function (response) {
        var dataObj = response.data; // console.log(response.data, dataObj !== undefined)

        if (dataObj !== undefined) {
          var totalSellerId = 999;
          var totalObj = {
            'sellerId': totalSellerId,
            'dailyCount': 0,
            'beforeAmount92': 0,
            'beforeNums92': 0,
            'beforeAmount95': 0,
            'beforeNums95': 0,
            'beforeAmountPetrol': 0,
            'beforeNumsPetrol': 0,
            'beforeAmount0': 0,
            'beforeNums0': 0,
            'beforeAmount': 0,
            'beforeNums': 0,
            'dailyPerNums': 0,
            'afterAmount92': 0,
            'afterNums92': 0,
            'afterAmount95': 0,
            'afterNums95': 0,
            'afterAmountPetrol': 0,
            'afterNumsPetrol': 0,
            'afterAmount0': 0,
            'afterNums0': 0,
            'afterAmount': 0,
            'afterNums': 0
          };
          Object.keys(dataObj).forEach(function (key) {
            var el = dataObj[key];
            totalObj.beforeAmount92 = NP.plus(totalObj.beforeAmount92, el.beforeAmount92);
            totalObj.beforeNums92 = NP.plus(totalObj.beforeNums92, el.beforeNums92);
            totalObj.beforeAmount95 = NP.plus(totalObj.beforeAmount95, el.beforeAmount95);
            totalObj.beforeNums95 = NP.plus(totalObj.beforeNums95, el.beforeNums95);
            totalObj.beforeAmount0 = NP.plus(totalObj.beforeAmount0, el.beforeAmount0);
            totalObj.beforeNums0 = NP.plus(totalObj.beforeNums0, el.beforeNums0);
            totalObj.beforeAmountPetrol = NP.plus(totalObj.beforeAmountPetrol, el.beforeAmountPetrol);
            totalObj.beforeNumsPetrol = NP.plus(totalObj.beforeNumsPetrol, el.beforeNumsPetrol);
            totalObj.beforeAmount = NP.plus(totalObj.beforeAmount, el.beforeAmount);
            totalObj.beforeNums = NP.plus(totalObj.beforeNums, el.beforeNums);
            totalObj.afterAmount92 = NP.plus(totalObj.afterAmount92, el.afterAmount92);
            totalObj.afterNums92 = NP.plus(totalObj.afterNums92, el.afterNums92);
            totalObj.afterAmount95 = NP.plus(totalObj.afterAmount95, el.afterAmount95);
            totalObj.afterNums95 = NP.plus(totalObj.afterNums95, el.afterNums95);
            totalObj.afterAmount0 = NP.plus(totalObj.afterAmount0, el.afterAmount0);
            totalObj.afterNums0 = NP.plus(totalObj.afterNums0, el.afterNums0);
            totalObj.afterAmountPetrol = NP.plus(totalObj.afterAmountPetrol, el.afterAmountPetrol);
            totalObj.afterNumsPetrol = NP.plus(totalObj.afterNumsPetrol, el.afterNumsPetrol);
            totalObj.afterAmount = NP.plus(totalObj.afterAmount, el.afterAmount);
            totalObj.afterNums = NP.plus(totalObj.afterNums, el.afterNums);
          });
          dataObj[totalSellerId] = totalObj;
        }

        _this.pieDataObj = dataObj;
        _this.loading = false;

        for (var i in _this.metrics) {
          var metric = _this.metrics[i]['title'];
          var xData1Key = _this.metrics[i]['key1'];
          var xData2Key = _this.metrics[i]['key2'];
          var xData3Key = _this.metrics[i]['key3'];
          _this.metrics[i]['value'] = 0;
          _this.metrics[i]['compare'] = 0;
          _this.xData[metric] = [];
          _this.xData2[metric] = [];

          for (var slot in _this.slotsMapping) {
            var seller = _this.slotsMapping[slot]['ID'];
            var value = 0;
            var compareValue = 0;

            if (dataObj !== {} && dataObj[seller] !== undefined && dataObj[seller][xData1Key] !== undefined) {
              value = dataObj[seller][xData1Key];
            }

            if (dataObj !== {} && dataObj[seller] !== undefined && dataObj[seller][xData3Key] !== undefined) {
              compareValue = dataObj[seller][xData3Key];
            }

            _this.xData[metric].push(value);

            _this.metrics[i]['value'] = NP.plus(_this.metrics[i]['value'], value);
            _this.metrics[i]['compare'] = NP.plus(_this.metrics[i]['compare'], compareValue);
            var value2 = 0;

            if (dataObj !== {} && dataObj[seller] !== undefined && dataObj[seller][xData2Key] !== undefined) {
              value2 = dataObj[seller][xData2Key];
            }

            _this.xData2[metric].push(value2);
          }

          _this.barData.push({
            name: metric,
            type: 'bar',
            stack: '2',
            data: _this.xData[metric]
          });

          _this.barData2.push({
            name: metric,
            type: 'bar',
            stack: '2',
            data: _this.xData2[metric]
          });
        }

        _this.render += 1;
        _this.showBarData = _this.barData;

        _this.getTotalAfterNumsSub();
      }).catch(function () {
        _this.loading = false;
      });
    },
    loadMonthData: function loadMonthData(sellerId) {
      var _this2 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData2 = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: sellerId,
          name: this.slotCounterName,
          start: this.date / 1000 - (this.queryDataDays > 0 ? this.queryDataDays * 24 * 60 * 60 : 31 * 24 * 60 * 60),
          end: this.date / 1000,
          search: ''
        }]
      };
      getMonthTotalCounter(descriptorData2).then(function (response) {
        // console.log(response.data)
        var dataObj = response.data;
        _this2.loading = false;

        for (var i in _this2.metrics) {
          var metric = _this2.metrics[i]['title'];
          var xData2Key = _this2.metrics[i]['key2'];
          _this2.xData3[metric] = [];

          for (var j in _this2.monthSlotsArr) {
            var slot = _this2.monthSlotsArr[j];
            var value = 0;

            if (dataObj !== {} && dataObj[slot] !== undefined && dataObj[slot][xData2Key] !== undefined) {
              value = dataObj[slot][xData2Key];
            }

            _this2.xData3[metric].push(value);
          }

          _this2.barData3.push({
            name: metric,
            type: 'bar',
            stack: '2',
            data: _this2.xData3[metric]
          });
        }

        _this2.render2 += 1;

        _this2.getSingleAfterNumsSub(sellerId);
      }).catch(function () {
        _this2.loading = false;
      });
    },
    monthSlots: function monthSlots() {
      var monthSlots = [];

      for (var timestamp = this.date / 1000 - (this.queryDataDays > 0 ? this.queryDataDays * 24 * 60 * 60 : 31 * 24 * 60 * 60); timestamp <= this.date / 1000 - 86400; timestamp += 86400) {
        monthSlots.push(dateUtils.normalFormatCus(timestamp * 1000, 'MMDD'));
      }

      return monthSlots;
    },
    selectedChange: function selectedChange() {
      this.showPopover = false;
      this.monthSlotsArr = this.monthSlots();

      var _that = this;

      if (this.selectedItemId > 0) {
        this.pieData = [];
        this.pieData2 = [];
        this.barData3 = [];
        this.showPieData = [];

        if (this.pieDataObj && this.pieDataObj[this.selectedItemId]) {
          var pieSellerData = this.pieDataObj[this.selectedItemId];
          this.metrics.forEach(function (el) {
            var pieDataItem = {};
            var pieDataItem2 = {};
            pieDataItem.name = el['title'];
            pieDataItem2.name = el['title'];
            pieDataItem.value = NP.round(NP.divide(pieSellerData[el['key1']], 10000), 2);
            pieDataItem2.value = NP.round(NP.divide(pieSellerData[el['key2']], 10000), 2);

            _that.pieData.push(pieDataItem);

            _that.pieData2.push(pieDataItem2);
          });
          this.showPieData = this.pieData;
        }

        this.render3 += 1;
        this.loadMonthData(this.selectedItemId);
      }
    }
  }
};